import type { FunctionComponent } from 'react';
import { LocationPageTitle } from '../../../components/LocationPageTitle/LocationPageTitle';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';

export const SuburbPageTitleWithData: FunctionComponent = () => {
  const titleParts = useSuburbPageQuery()?.data?.suburbPageBySlug?.title?.parts;
  if (!titleParts) return null;

  const [title, subtitle] = titleParts;
  if (!title) return null;

  return <LocationPageTitle title={title} subtitle={subtitle} />;
};
